
<template>
    <div>
        <loading :active.sync="isLoading" :is-full-page="true" loader="dots" :height="150" :width="150" color="#ff5900"></loading>
        <div v-if="!seeExclusive">
            <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardBody>
                        <CBadge shape="pill" color="primary" class="mr5" v-c-tooltip="{content: 'Cupo máximo'}">{{evento.cupoMaximo == 0 ? 'N/A' : evento.cupoMaximo}}</CBadge>
                        <CBadge shape="pill" color="success" class="mr5" v-c-tooltip="{content: 'Inscritos'}">{{totalInscritos}}</CBadge>
                        <CBadge shape="pill" color="warning" class="mr5" v-c-tooltip="{content: 'Cupo disponible'}">{{evento.cupoMaximo == 0 ? 'N/A' : evento.cupoDisponible}}</CBadge>
                        <CBadge shape="pill" color="info" class="mr5" v-c-tooltip="{content: 'Total con Check-In'}">{{totalCheckIn}}</CBadge>
                        <CBadge shape="pill" color="info" class="mr5" v-c-tooltip="{content: 'Total con Check-Out'}">{{totalCheckOut}}</CBadge>
                        <CForm inline class="float-right" v-on:submit.prevent="obtenerInscritos">
                            <CInput class="mr-2 my-0" placeholder="Buscar" v-model="filtros['nombre']" size="sm">                      
                                <template #append>
                                    <CButton class="mr-2" color="info" size="sm" @click="obtenerInscritos">
                                        <font-awesome-icon :icon="['fas', 'search']" />   
                                    </CButton>
                                </template>
                            </CInput>
                            <CButton color="primary" size="sm" @click="abrirDialogoIncribir=true">
                                <font-awesome-icon :icon="['fas', 'plus']" />    
                            </CButton>
                            <download-excel v-c-tooltip="{content: 'Exportar participantes'}"
                                class="btn btn-success btn-sm ml5"
                                worksheet="Inscritos"
                                name="Inscritos.xls"
                                :fetch="fetchData"
                                :fields="json_fields"
                                :before-generate="startDownload"
                                :before-finish="finishDownload">
                                <font-awesome-icon :icon="['fas', 'file-excel']" />
                            </download-excel>
                            <CButton color="warning" v-c-tooltip="{content: 'Importar participantes'}" class="ml5" size="sm" @click="abrirDialogoImportar=true">
                                <font-awesome-icon :icon="['fas', 'file-import']" />    
                            </CButton>
                            <CButton color="info" v-c-tooltip="{content: 'Participantes exclusivos'}" class="ml5" size="sm" @click="seeExclusive=true">
                                <font-awesome-icon :icon="['fas', 'user-lock']" />    
                            </CButton>
                        </CForm>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CRow class="justify-content-center" v-if="cargando"> 
            <div class="spinner-grow text-warning m10" role="status" v-for="i in [ 1, 2, 3 ]"  v-bind:key="i">
                <span class="sr-only">Cargando...</span>
            </div>
        </CRow>
        
        <CRow v-if="elementos.length">
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <h5 class="text-warning">Inscritos de {{evento.nombre}}</h5>
                    </CCardHeader>
                    <CCardBody class="table-responsive">
                        <table class="table table-sm table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>ID Anáhuac</th>
                                    <th>Nombre</th>
                                    <th>Email</th>
                                    <th>F. Inscripción</th>
                                    <th>T. Check-In</th>
                                    <th>T. Check-Out</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(elemento, index) in elementos" v-bind:key="index">
                                    <td>{{elemento.idBanner}}</td>
                                    <td>{{elemento.nombre + ' ' + elemento.apellido}}</td>
                                    <td>{{elemento.email}}</td>
                                    <td>{{elemento.fechaRegistro}}</td>
                                    <td>{{elemento.totalCheckin}}</td>
                                    <td>{{elemento.totalCheckout}}</td>
                                    <td>
                                        <CButton v-if="elemento.totalCheckin == 0 && elemento.totalCheckout == 0" 
                                        color="light" shape="pill" class="card-icon-button" @click="eliminarInscripcion(elemento.id, elemento.idEvento, elemento.email, elemento)">
                                            <font-awesome-icon style="color:#c00" :icon="['fas', 'trash']" />    
                                        </CButton>
                                        <CButton v-if="oUser.user.idPerfil == 1 || oUser.user.idPerfil == 2"
                                        color="success" shape="pill" style="height: 40px; width: 40px;" @click="dialogoFechasAsistencia(elemento.idEvento, elemento.idUsuario)">
                                            <font-awesome-icon :icon="['fas', 'check']" />    
                                        </CButton>
                                        
                                    </td>
                                </tr> 
                            </tbody>  
                        </table>
                    </CCardBody>
                </CCard>
            </CCol>  
        </CRow>
        <CRow v-if="!elementos.length && !cargando">
            <CCol sm="12">
                <alert-sin-resultados v-if="!elementos.length && !error"></alert-sin-resultados>    
                <alert-error v-else-if="error"></alert-error>    
            </CCol>
        </CRow>
        <CRow>
            <CCol sm="12">
                <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5" @paginate="obtenerInscritos()"></pagination>
            </CCol>
        </CRow>
        </div>
        <div v-if="seeExclusive">
            <CCard>
                <CCardHeader class="title">
                    <p>
                        Lista de integrantes exclusivos
                    </p>
                   <CRow>
                        <CButton type="button" color="success" class="ml5" size="sm" @click="seeExclusive= false">
                            Volver a inscritos   
                        </CButton>
                        <CButton type="button" color="primary" class="ml5" size="sm" @click="showExclusiveModal= true">
                            <font-awesome-icon :icon="['fas', 'user']" /> Agregar usuario
                        </CButton>

                   </CRow>
                </CCardHeader>
                <CCardBody>
                    <h5 class="text-warning">Participantes exclusivos de {{evento.nombre}}</h5>
                    <table v-if="exclusivos.length > 0" class="table table-sm table-striped table-bordered">
                        <thead>
                           <tr>
                                <th>ID Anáhuac</th>
                                <th>Nombre</th>
                                <th>Email</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(elemento, index) in exclusivos" v-bind:key="index">
                                <td>
                                    {{elemento.idAnahuac}}
                                </td>
                                <td>
                                    {{elemento.nombre}} {{elemento.apellidoPaterno}} {{elemento.apellidoMaterno ? elemento.apellidoMaterno :  ""}}
                                </td>
                                <td>
                                    {{elemento.email}}
                                </td>
                                <td>
                                    <CButton
                                    color="light" shape="pill" class="card-icon-button" @click="deleteExclusive(index)">
                                        <font-awesome-icon style="color:#c00" :icon="['fas', 'trash']" />    
                                    </CButton>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </CCardBody>
            </CCard>
        </div>
        
        <CModal
            title="Agregar participante exclusivo"
            color="warning"
            :show.sync ="showExclusiveModal"
             @keydown.esc="showExclusiveModal=false;">

            <CRow>
                <CCol md="12">
                    <cool-select
                        :items="items"
                        :loading="loading"
                        item-text="nombre"
                        placeholder="Escriba para buscar y seleccionar"
                        disable-filtering-by-search
                        @search="onSearch"
                        >
                            <template #no-data>
                                {{
                                    noData
                                    ? "No se encontraron coincidencias."
                                    : "Escriba más de " + numLetras + " letras para buscar."
                                }}
                            </template>
                            <template #item="{ item }">
                                <div class="item" @click="addExclusive(item)">
                                    <div>
                                        <span class="item-name">{{ ( item.idAnahuac != null ? '(' + item.idAnahuac + ')' : '') + item.nombre + ' ' + item.apellidoPaterno + ' ' + item.apellidoMaterno }}</span><br />
                                    </div>
                                </div>
                            </template>
                            <template #input-end>
                                <!-- You can use your own loading spinner -->
                                <font-awesome-icon v-if="loading" icon="spinner" pulse/>
                                <font-awesome-icon v-else icon="search"/>    
                            </template>
                        </cool-select>
                </CCol>
                <CCol md="12" v-show="exclusivos.length > 0">
                    <CCardBody class="table-responsive">
                        <table class="table table-sm table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>ID Anáhuac</th>
                                    <th>Nombre</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(p, index) in exclusivos" v-bind:key="index">
                                    <td style="width:80px">{{p.idAnahuac}}</td>
                                    <td>{{p.nombre + ' ' + p.apellidoPaterno + ' ' + (p.apellidoMaterno ? p.apellidoMaterno :"")}}</td>
                                    <td style="width:35px">
                                        <CButton size="sm" shape="pill" class="btn btn-danger"  @click="removeExclusive(index)">
                                            <font-awesome-icon :icon="['fas', 'trash']" />    
                                        </CButton>
                                    </td>
                                </tr> 
                            </tbody>  
                        </table>
                    </CCardBody>
                </CCol>
            </CRow>
            <div slot="footer">
                <CButton color="light" class="mr5" size="sm" @click="showExclusiveModal=false;">
                    <font-awesome-icon :icon="['fas', 'times-circle']" /> Cerrar
                </CButton>
                <CButton color="success" type="submit" size="sm" class="float-right" @click="registrarExclusivos" :disabled="guardando">
                    <font-awesome-icon :icon="['fas', 'save']" /> Guardar    
                </CButton> 
            </div>

        </CModal>

        <CModal
            title="Inscribir usuario al evento"
            color="warning"
            :show.sync="abrirDialogoIncribir"
            @keydown.esc="abrirDialogoIncribir=false;nuevosParticipantes=[];"
            >
                <alert-info class="mt20" msgInfo="En este apartado podrá inscribir usuarios registrados en el sistema sin realizarle ningún tipo de cobro."></alert-info>        
                <CRow>
                    <CCol md="12">
                        <cool-select
                            v-model="selected"
                            :items="items"
                            :loading="loading"
                            item-text="nombre"
                            placeholder="Escriba para buscar y seleccionar"
                            disable-filtering-by-search
                            @search="onSearch"
                            >
                                <template #no-data>
                                    {{
                                        noData
                                        ? "No se encontraron coincidencias."
                                        : "Escriba más de " + numLetras + " letras para buscar."
                                    }}
                                </template>
                                <template #item="{ item }">
                                    <div class="item">
                                        <div>
                                            <span class="item-name">{{ ( item.idAnahuac != null ? '(' + item.idAnahuac + ')' : '') + item.nombre + ' ' + item.apellidoPaterno + ' ' + item.apellidoMaterno }}</span><br />
                                        </div>
                                    </div>
                                </template>
                                <template #input-end>
                                    <!-- You can use your own loading spinner -->
                                    <font-awesome-icon v-if="loading" icon="spinner" pulse/>
                                    <font-awesome-icon v-else icon="search"/>    
                                </template>
                            </cool-select>
                    </CCol>
                    <CCol md="12" v-show="nuevosParticipantes.length > 0">
                        <CCardBody class="table-responsive">
                            <table class="table table-sm table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th>ID Anáhuac</th>
                                        <th>Nombre</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(p, index) in nuevosParticipantes" v-bind:key="index">
                                        <td style="width:80px">{{p.idBanner}}</td>
                                        <td>{{p.nombre + ' ' + p.apellido}}</td>
                                        <td style="width:35px">
                                            <CButton size="sm" shape="pill" class="btn btn-danger"  @click="removerParticipante(index)">
                                                <font-awesome-icon :icon="['fas', 'trash']" />    
                                            </CButton>
                                        </td>
                                    </tr> 
                                </tbody>  
                            </table>
                        </CCardBody>
                    </CCol>
                </CRow>
                <div slot="footer">
                    <CButton color="light" class="mr5" size="sm" @click="abrirDialogoIncribir=false;nuevosParticipantes=[];">
                        <font-awesome-icon :icon="['fas', 'times-circle']" /> Cerrar
                    </CButton>
                    <CButton color="success" type="submit" size="sm" class="float-right" @click="registrarParticipantes" :disabled="guardando">
                        <font-awesome-icon :icon="['fas', 'save']" /> Guardar    
                    </CButton> 
                </div>    
        </CModal>
         <CModal
            title="Importar participantes al evento"
            color="warning"
            :show.sync="abrirDialogoImportar"
            @keydown.esc="abrirDialogoImportar=false;"
            >
                <alert-info class="mt20" msgInfo="La cuenta de correo de los usuarios a inscribir debe existir en la base de datos."></alert-info> 
                <strong>Cargue un archivo colocando la información en el siguiente orden:
                    <br>Col A (ID Banner), Col B (Nombre), Col C (Apellido), Col D (Email)
                </strong>  
                <img src="/excel/EjemploImportarParticipante.PNG" class="c-sidebar-brand-full" alt="Apoyo visual" />
                <br><br>
                <CRow>
                    <CCol md="12">
                        <label class="form-control-label"  for="input-file-import">Cargar archivo de Excel</label>
                        <input type="file" class="form-control" id="input-file-import" name="file_import" ref="importFile"  @change="onFileChange">
                    </CCol>
                </CRow>
                <alert-error v-if="error"></alert-error>    
                <div slot="footer">
                    <CButton color="light" class="mr5" size="sm" @click="abrirDialogoImportar=false;">
                        <font-awesome-icon :icon="['fas', 'times-circle']" /> Cerrar
                    </CButton> 
                    <CButton color="success" type="submit" size="sm" class="float-right" @click="importarArchivo" :disabled="guardando">
                        <font-awesome-icon :icon="['fas', 'save']" /> Importar    
                    </CButton>
                </div>    
        </CModal>

        <CModal v-if="oUser.user.idPerfil == 1 || oUser.user.idPerfil == 2" 
            title="Registro de asistencia"
            color="warning"
            :show.sync="abrirDialogoAsistencia"
            @keydown.esc="abrirDialogoAsistencia=false;"
            >
                <h5>Seleccione el día de la asistencia</h5>  
                <alert-error v-if="error"></alert-error>    
                <table class="table table-sm table-striped table-bordered">
                    <thead>
                        <tr>
                            <th>Fecha del Evento</th>
                            <th>Check-In</th>
                            <th v-if="evento.permiteCheckOut == 1">Check-Out</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(p, index) in diasAsistencia" v-bind:key="index">
                            <td>{{p.fecha}}</td>
                            <td style="width:30px">
                                <CSwitch v-bind="labelIcon" :id="'checkin' + index" :color="'success'" variant="3d"
                                @update:checked="(val) => seteaAsistencia(val, index)"
                                :checked="p.checkIn == 1" value="1"/>
                            </td>
                            <td style="width:30px" v-if="evento.permiteCheckOut == 1">
                                <CSwitch v-bind="labelIcon" :disabled="p.checkIn == 0" :id="'checkout' + index" :color="'success'" variant="3d"
                                @update:checked="(val) => val ? p.checkOut = 1 : p.checkOut = 0"
                                :checked="p.checkOut == 1" value="1"/>
                            </td>
                        </tr> 
                    </tbody>  
                </table>
                <div slot="footer">
                    <CButton color="light" class="mr5" size="sm" @click="abrirDialogoAsistencia=false;">
                        <font-awesome-icon :icon="['fas', 'times-circle']" /> Cerrar
                    </CButton> 
                    <CButton color="success" type="submit" size="sm" class="float-right" @click="registrarAsistencias" :disabled="guardando">
                        <font-awesome-icon :icon="['fas', 'save']" /> Guardar    
                    </CButton>
                </div>    
        </CModal>
    </div>    
</template>
<script>
import cryptoJs from '../../services/CryptoJsService';
import { CoolSelect } from "vue-cool-select";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import downloadExcel from "vue-json-excel";

export default {
    name: 'EventoInscritos',
    components: { cryptoJs, CoolSelect, Loading, downloadExcel },
    data () {
        return {
            id: 0,
            exclusivos: [],
            usuariosExclusivos: [],
            seeExclusive: false,
            showExclusiveModal: false,
            labelIcon: {
                labelOn: '\u2713',
                labelOff: '\u2715'
            },
            router: this.$router,
            basePath: process.env.VUE_APP_API_URL,
            cargando: false,
            error: false,
            filtros: {},
            evento: {},
            elementos: [],
            pagination: { 'current_page': 1 },
            oUser: this.$AuthApiService.getDataLocalStorage(),
            abrirDialogoIncribir: false,
            selected: null,
            items: [],
            loading: false,
            noData: false,
            numLetras: 3,
            nuevosParticipantes: [],
            guardando: false,
            isLoading: false,
            json_fields: {
                'EVENTO': 'eventoNombre',
                'ID ANÁHUAC': 'idBanner',
                'NOMBRE': 'nombre',
                'APELLIDO': 'apellido',
                'EMAIL': 'email',
                'FECHA INSCRIPCIÓN': 'fechaRegistro',
                'T. CHECK-IN': 'totalCheckin',
                'T. CHECK-OUT': 'totalCheckout',
                'PAGO': 'costo',
                'PROGRAMA': 'programa',
                'CLASE': 'clase',
                'CAMPUS': 'campus',
                'CAMPO ESTUDIO': 'campoEstudio'
            },
            totalCheckIn: 0,
            totalCheckOut: 0,
            abrirDialogoImportar: false,
            importFile: '',
            totalInscritos: 0,
            listaDeinscritos: [],
            abrirDialogoAsistencia: false,
            diasAsistencia: []
        }
    },
    methods: {
        removeExclusive(index) {
            this.usuariosExclusivos.splice(index, 1);
        },
        addExclusive(item) {
            console.log(item);
            this.usuariosExclusivos.push(item);
        },
        async deleteExclusive(index) {
            const result = await this.$swal({
                title: '¿Estás segur@ de eliminar al usuario exclusivo?',
                text: "",
                icon: 'info', 
                buttons: [
                    'Cancelar',
                    'Sí, eliminar'
                ]
            });

            if (result) {
                const r = await this.$AuthApiService.getAccessToken();
                const response = await this.$axios.post(this.basePath + 'api/evento/exclusivos/eliminar',{
                    "eventId": this.evento.id,
                    "exclusive": this.exclusivos[index].id,
                    "updated": this.oUser.user.id
                }, {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token, 'content-type': 'application/json' }
                });

                if (response.data.success) {
                    this.exclusivos.splice(index, 1);
                }
            }
        },
        async registrarExclusivos() {
            const only_Ids = [];

            this.usuariosExclusivos.map((item) => {
                only_Ids.push(item.id);
            });


            if (this.evento.id) {
                const r = await this.$AuthApiService.getAccessToken();
                const response = await this.$axios.post(this.basePath + 'api/evento/exclusivos/registrar',{
                    "eventId": this.evento.id,
                    "exclusives": [...only_Ids],
                    "updated": this.oUser.user.id
                }, {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token, 'content-type': 'application/json' }
                });

                if (response.data.success) {
                    window.location.reload();
                } else {
                    // TODO: Not success
                }

            }


        },
        seteaAsistencia(val, index) {
            if (val) { 
                this.diasAsistencia[index].checkIn = 1; 
            } else { 
                this.diasAsistencia[index].checkIn = 0;
                this.diasAsistencia[index].checkOut = 0;  
            }
        },
        onFileChange(e) {
            this.importFile = e.target.files[0];
        },
        dialogoFechasAsistencia(idEvento, idUsuario) {
            this.diasAsistencia = [];
            this.isLoading = true;
            this.abrirDialogoAsistencia = true;
            this.error = false; 
            this.$AuthApiService.getAccessToken().then(r => 
                this.$axios.get(this.basePath + 'api/asistencia/evento/' + idEvento + '/' + idUsuario, {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token, 'content-type': 'multipart/form-data' }
                })
                .then(response => {
                    this.diasAsistencia = response.data.data;
                    this.isLoading = false;
                    

                })
                .catch(error => {
                    this.error = true;
                    this.abrirDialogoAsistencia = false;
                    this.isLoading = false;
                })
            );
        },
        registrarAsistencias() {
            this.isLoading = true;
            this.error = false; 
            this.guardando = true;
            this.$AuthApiService.getAccessToken().then(r => 
                this.$axios.post(this.basePath + 'api/asistencia/registrar-fechas', this.diasAsistencia, {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                })
                .then(response => {
                    this.obtenerInscritos();
                    this.abrirDialogoAsistencia = false;
                    this.guardando = false;
                    this.isLoading = false;
                    if (this.evento.tipoEvento == "VFI Pass" && this.evento.claveCampus == "UAM" ) {
                        for (const assists of this.diasAsistencia) {
                            const user = this.elementos.find(x => x.idUsuario == assists.idUsuario);
                            if (user) {
                                this.VFIService.markVFIComplete(
                                    idEvento,
                                    user.email,
                                );
                            }
                        }
                    }
                    
                    this.diasAsistencia = [];
                })
                .catch(error => {
                    this.error = true;
                    this.abrirDialogoAsistencia = false;
                    this.guardando = false;
                    this.isLoading = false;
                })
            );
        },
        importarArchivo() {
            let formData = new FormData();
            formData.append('importFile', this.importFile);

            this.isLoading = true;
            this.error = false; 
            this.guardando = true;
            this.$AuthApiService.getAccessToken().then(r => 
                this.$axios.post(this.basePath + 'api/integrante/import/' + this.id, formData, {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token, 'content-type': 'multipart/form-data' }
                })
                .then(response => {
                    this.obtenerInscritos(true);

                    this.abrirDialogoImportar = false;
                    this.guardando = false;
                    this.isLoading = false;
                    this.importFile = '';
                    this.$refs.importFile.value=null;
                })
                .catch(error => {
                    this.error = true;
                    this.abrirDialogoImportar = false;
                    this.guardando = false;
                    this.isLoading = false;
                    this.importFile = '';
                    this.$refs.importFile.value=null;
                })
            );
        },
        fetchData() {
            return this.listaDeinscritos;
        },
        async obtenerTodosLosInscritos() {
            const oHeaders = { headers: { 'Authorization': this.oUser.token_type + ' ' + this.oUser.access_token } };
            const response = await this.$axios.get(this.basePath + 'api/inscritos/' + this.id + '/evento?limit=0', oHeaders);
            const inscritos = response.data.data;
            for (let i in inscritos) {
                if (inscritos[i].totalCheckin > 0) {
                    this.totalCheckIn++;
                }
                if (inscritos[i].totalCheckout > 0) {
                    this.totalCheckOut++;
                }
            }
            return inscritos;
        },
        startDownload(){
            this.isLoading = true;
        },
        finishDownload(){
            this.isLoading = false;
        },
        removerParticipante(indice) {
            this.nuevosParticipantes.splice(indice, 1);
        },
        async onSearch(search) {
            this.noData = false;
            if (search.length < this.numLetras) {
                this.items = [];
                this.loading = false;
                return;
            }
            this.loading = true;

            clearTimeout(this.timeoutId);
            const filtros = { 
                idAnahuac: search,
                nombre: search,
                apellidoPaterno: search,
                apellidoMaterno: search
            };
            const params = '&' + this.queryString(filtros);
            
            this.timeoutId = setTimeout(async () => {
                const oHeaders = { headers: { 'Authorization': this.oUser.token_type + ' ' + this.oUser.access_token } };
                const response = await this.$axios.get(this.basePath + 'api/usuarios?limit=10&activo=1' + params, oHeaders);
                this.items = await response.data.data.data;
                this.loading = false;

                if (!this.items.length) this.noData = true;
            }, 500);
        },
        queryString(obj) {
            var str = [];
            for (var p in obj) {
                if (obj.hasOwnProperty(p) && obj[p] != '' && obj[p] != null) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            }
            return str.join("&");
        },
        obtenerInscritos(wasImported = false) {
            if (this.elementos.length == 0) {
                this.cargando = true;
            }
            this.error = false;
            let params = "";
            if (Object.keys(this.filtros).length > 0) {
                if (this.filtros.nombre != '') {
                    this.filtros.apellido = this.filtros.nombre;
                    this.filtros.idBanner = this.filtros.nombre;
                    this.filtros.email = this.filtros.nombre;
                } else {
                    delete this.filtros.apellido;
                    delete this.filtros.idBanner;
                    delete this.filtros.email;
                }
                params += '&' + this.queryString(this.filtros);
            }
            this.$AuthApiService.getAccessToken().then(r => 
                this.$axios.get(this.basePath + 'api/inscritos/' + this.id + '/evento?page=' + this.pagination.current_page + params, {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                })
                .then(async (response) => {
                    this.cargando = false;
                    this.elementos = response.data.data.data;
                    this.pagination = response.data.data;
                    this.totalInscritos = response.data.data.total;
                    if (wasImported === true) {
                        this.listaDeinscritos = await this.obtenerTodosLosInscritos();
                        this.getEmailStudentsForNotification(this.id, this.listaDeinscritos, this.evento);
                    }
                })
                .catch(error => {
                    this.cargando = false;
                    this.error = true;
                })
            );
        },
        getEmailStudentsForNotification(eventId, students, eventData) {

            const emails = [];
            for (const student of students) {
                emails.push(student.email);
            }

            this.$notificationService.markNotificationForAllStudents(eventId, emails, eventData);
        },
        obtenerEvento() {
            this.$AuthApiService.getAccessToken().then(r => 
                this.$axios.get(this.basePath + 'api/eventos/' + this.id, {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                })
                .then(response => {
                    this.evento = response.data.data;
                    this.evento.exclusivos.map((item) => {
                        this.exclusivos.push({
                            ...item.usuario
                        })
                    });
                    
                })
                .catch(error => {
                    console.log(error.response);
                })
            );
        },
        eliminarInscripcion(id, idEvento, email, evento = {}) {
            this.$swal({
                title: '¿Estás segur@ de eliminar la inscripción?',
                text: "El registro se eliminará de manera permanente",
                icon: 'warning', 
                buttons: [
                    'Cancelar',
                    'Si, eliminar inscripción'
                ],
                dangerMode: true
            }).then((isConfirmed) => {
                if (isConfirmed) {
                    this.$AuthApiService.getAccessToken().then(r => 
                        this.$axios.delete(this.basePath + 'api/inscritos/' + id, {
                            headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                        })
                        .then(r => {
                            if (r.data.error == 1) {
                                let mensajeError = "";
                                if (typeof r.data.message == 'string') {
                                    mensajeError = r.data.message;
                                } else {
                                    for (let i in r.data.message) {
                                        for (let j in r.data.message[i]) {
                                            mensajeError += r.data.message[i][j] + '. ';
                                        }
                                    }
                                }
                                this.alertFallido(mensajeError);
                            } else {
                                swal(r.data.message, {
                                    icon: "success"
                                });
                                this.obtenerInscritos();
                                this.$notificationService.removeEventNotification(
                                    {
                                        event: {
                                            id: idEvento
                                        },
                                        notification: {
                                            id: email ? email : this.oUser.user.email
                                        }
                                    }
                                );

                                if(evento && evento.requiereCalificacion) {
                                    this.$notificationService.removeRatingNotification({
                                        event: {
                                            id: idEvento
                                        },
                                        student: this.authData.user.email,
                                        
                                    });
                                }
                            }
                        })
                        .catch(error => {
                            this.alertFallido("Error al intentar realizar la acción");
                        })
                    );
                }
            });
        },
        alertFallido(textMsg) {
            this.$swal({
                title: "Ocurrio un Error",
                text: textMsg,
                icon: "error",
            })
            .then((value) => {
                this.obtenerInscritos();
            });
        },
        registrarParticipantes() {
            
            if (this.nuevosParticipantes.length == 0)
            return;

            let eventId = this.nuevosParticipantes[0].idEvento;
            const emails = [];
            for (const participant of this.nuevosParticipantes) {
                emails.push(participant.email);
            }

            this.isLoading = true;
            this.error = false; 
            this.guardando = true;   
            this.$AuthApiService.getAccessToken().then(r => 
                this.$axios.post(this.basePath + 'api/registra/participantes', this.nuevosParticipantes, {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                })
                .then(response => {
                    this.$notificationService.markNotificationForAllStudents(eventId, emails, this.evento);

                    this.obtenerInscritos();
                    this.abrirDialogoIncribir = false;
                    this.nuevosParticipantes = [];
                    this.guardando = false;
                    this.isLoading = false;
                })
                .catch(error => {
                    this.error = true;
                    this.abrirDialogoIncribir = false;
                    this.guardando = false;
                    this.isLoading = false;
                })
            );
        }
    },
    watch: {
        selected: function (val) {
            if (this.selected != null) {
                const participante = { 
                    'idUsuario': val.id, 
                    'idEvento': this.id,
                    'idBanner': val.idAnahuac,
                    'nombre': val.nombre,
                    'apellido': val.apellidoPaterno + ' ' + val.apellidoMaterno,
                    'email': val.email
                };
                this.nuevosParticipantes.push(participante);
                this.selected = null;
            }
        }
    },
    mounted() {
        this.id = parseInt(cryptoJs.decrypt(this.$route.query.ev), 10);
        if (this.id > 0) {
            this.obtenerEvento();
            this.obtenerInscritos();
            this.listaDeinscritos = this.obtenerTodosLosInscritos();
        }
    },
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString().toLowerCase()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    }
}
</script>
<style>
.delete-button {
    background-color: #D50000 !important;
    border-radius: 30px !important;
    height: 30px !important;
    width: 30px !important;
    margin: 0px !important;
}
</style>